export const SeedSource = Object.freeze({
    NEW: "new",
})
